import { FloatingTree } from '@floating-ui/react';
import React, { useMemo } from 'react';
import { ContextMenuColumn } from "./components/ContextMenuColumn/ContextMenuColumn.js";
import { SelectContext } from "./context/SelectContext.js";
import { SettingsContext } from "./context/SettingsContext.js";
import { markCheckedItems } from "./functions/markCheckedItems.js";
import { MobileCheckProvider } from "./provider/MobileCheckProvider/MobileCheckProvider.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ContextMenu({
  isNullable,
  items,
  selectedItem,
  onSelect,
  nullLabel,
  inlineSearch,
  externalSearch,
  className,
  style,
  favoritesLabel,
  inlineFolder,
  filterFn,
  inputPlaceholder,
  optionWrapper,
  getOffsetOptions,
  getAutoPlacement,
  ...columnProps
}) {
  const itemsNew = useMemo(() => {
    const itemsWithNullable = isNullable ? [{
      type: 'null',
      label: nullLabel ?? '-'
    }, ...items] : items;
    markCheckedItems(itemsWithNullable, selectedItem);
    return itemsWithNullable;
  }, [items, isNullable, nullLabel, selectedItem]);
  const settingsData = useMemo(() => ({
    inlineSearch,
    externalSearch,
    className,
    style,
    favoritesLabel,
    inlineFolder,
    filterFn,
    inputPlaceholder,
    optionWrapper,
    getOffsetOptions,
    getAutoPlacement
  }), [inlineSearch, externalSearch, className, style, favoritesLabel, inlineFolder, filterFn, inputPlaceholder, optionWrapper, getOffsetOptions, getAutoPlacement]);
  const selectData = useMemo(() => ({
    onSelect
    // type cast required here because onSelect type depends on the isNullable option
  }), [onSelect]);
  return /*#__PURE__*/_jsx(SettingsContext.Provider, {
    value: settingsData,
    children: /*#__PURE__*/_jsx(SelectContext.Provider, {
      value: selectData,
      children: /*#__PURE__*/_jsx(MobileCheckProvider, {
        children: /*#__PURE__*/_jsx(FloatingTree, {
          children: /*#__PURE__*/_jsx(ContextMenuColumn, {
            items: itemsNew
            // Always show the search input for the first column if inline-search is true
            ,
            showSearchInput: inlineSearch ?? false,
            ...columnProps
          })
        })
      })
    })
  });
}

/**
 * @deprecated This component has been renamed to ContextMenu
 */
export const FloatingSelect = ContextMenu;

/**
 * @deprecated This type has been renamed to ContextMenuProps
 */